/**
 * GeoManager — Shared State & Configuration
 *
 * Single source of truth for all GeoManager state.
 * Imported by every other module.
 */

export const state = {
    folders: [],
    points: [],
    customIcons: [],
    selectedFolder: null,
    selectedPoint: null,
    map: null,
    markers: {},
    zones: {},
    markerClusterGroup: null,
    heatmapLayer: null,
    convexHullLayer: null,
    legendControl: null,
    routePolyline: null,
    routeMarkers: [],
    clusteringEnabled: true,
    convexHullEnabled: false,
    initialized: false,
    mapClickHandler: null,
    loadDataInProgress: false,
    loadDataPromise: null,
    stateChanged: false,
    lastSavedStateHash: null,
    eventListeners: [],
    coverageZoneType: 'minutes',
};

export const config = {
    apiBase: '/api/geo-manager',
    defaultColor: '#2563eb',
    defaultZoneColor: '#10b981',
    defaultZoneOpacity: 0.3,
    icons: {
        preset: {
            'default': { icon: 'fa-map-marker-alt', color: '#2563eb' },
            'store': { icon: 'fa-store', color: '#10b981' },
            'restaurant': { icon: 'fa-utensils', color: '#f59e0b' },
            'hotel': { icon: 'fa-hotel', color: '#8b5cf6' },
            'warehouse': { icon: 'fa-warehouse', color: '#6b7280' },
            'office': { icon: 'fa-building', color: '#3b82f6' },
            'factory': { icon: 'fa-industry', color: '#78716c' },
            'hospital': { icon: 'fa-hospital', color: '#ef4444' },
            'school': { icon: 'fa-school', color: '#14b8a6' },
            'gas': { icon: 'fa-gas-pump', color: '#f97316' },
            'parking': { icon: 'fa-parking', color: '#0ea5e9' },
            'home': { icon: 'fa-home', color: '#22c55e' },
            'star': { icon: 'fa-star', color: '#eab308' },
            'flag': { icon: 'fa-flag', color: '#dc2626' },
        }
    },
    folderIcons: {
        'folder': 'fa-folder',
        'franchise': 'fa-store-alt',
        'prospect': 'fa-user-plus',
        'competitor': 'fa-users',
        'region': 'fa-map',
    }
};

export const eventManager = {
    add(element, event, handler, options = false) {
        if (!element) return;
        element.addEventListener(event, handler, options);
        state.eventListeners.push({ element, event, handler, options });
    },

    removeAll() {
        state.eventListeners.forEach(({ element, event, handler, options }) => {
            if (element) {
                try { element.removeEventListener(event, handler, options); } catch (e) {}
            }
        });
        state.eventListeners = [];
    },

    removeForElement(element) {
        state.eventListeners = state.eventListeners.filter(listener => {
            if (listener.element === element) {
                try { element.removeEventListener(listener.event, listener.handler, listener.options); } catch (e) {}
                return false;
            }
            return true;
        });
    }
};
